import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Tag, TagColor, getIconCode, Icon, IconSize, IconName, Group, GroupGutter, Box } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { getProductPriceOverlayTagColorAndContent, getNewProductOverlayTagColorAndTranslationKey, } from '../../../util/ProductUtil';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { useFeatureToggle } from '../../../hooks/useFeatureToggle';
const LabelsOverlay = ({ showGenderIcon, genderFeatureId, savingsPercentage, priceOverlay, showNewProductLabel, showOnlineExclusiveLabel, showSustainabilityLabel, hasWideGutter, dataQA, maxLabels, }) => {
    const { mainWebShop, market } = useAemConfig();
    const showOurPlanet = useFeatureToggle('our_planet');
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const labels = [];
    const labelsToShow = maxLabels ? maxLabels : market === 'nl' ? 2 : 3;
    const { overlayTagColor, overlayTagContent } = getProductPriceOverlayTagColorAndContent(priceOverlay);
    const showGenderLabel = showGenderIcon && genderFeatureId && getIconCode(genderFeatureId);
    if (showGenderLabel) {
        labels.push(_jsx(Tag, { dataQA: "gender_icon", color: TagColor.GENERAL, children: _jsx(Icon, { name: getIconCode(genderFeatureId), size: IconSize.MINOR }) }, "gender_icon"));
    }
    if (savingsPercentage && savingsPercentage > 0) {
        labels.push(_jsx(Tag, { color: TagColor.DISCOUNT, dataQA: "savings_percentage", children: `-${savingsPercentage}%` }, "dynamic_discount_label"));
    }
    if (overlayTagContent) {
        labels.push(_jsx(Tag, { color: overlayTagColor, dataQA: "price_overlay", children: overlayTagContent }, "commercial_label"));
    }
    if (showNewProductLabel) {
        const { tagColor, translationKey } = getNewProductOverlayTagColorAndTranslationKey(mainWebShop);
        labels.push(_jsx(Tag, { color: tagColor, children: t(translationKey) }, "new_product_label"));
    }
    if (showOnlineExclusiveLabel) {
        labels.push(_jsx(Tag, { dataQA: "online_exclusive", children: t('pdp.overlay.onlineexclusive') }, "online_exclusive_label"));
    }
    if (showSustainabilityLabel && showOurPlanet) {
        labels.push(_jsx(Tag, { color: TagColor.SUSTAINABLE, children: _jsxs(Group, { children: [_jsx("span", { children: t('product.sustainable') }), _jsx(Icon, { name: IconName.LEAF })] }) }, "sustainability_label"));
    }
    if (labels.length === 0) {
        return null;
    }
    return (_jsx(Box, { mobile: { spacing: { marginBottom: hasWideGutter ? 1 : 0 } }, children: _jsx(Group, { dataQA: dataQA, gutter: hasWideGutter ? GroupGutter.SMALL : { mobile: GroupGutter.XSMALL, desktop: GroupGutter.SMALL }, children: labels.slice(0, labelsToShow) }) }));
};
export default LabelsOverlay;
